import React from 'react';
import { NoTranslate } from '@shared/components/no-translate/no-translate';
import { CampaignNameFieldText } from './campaign-name-field.styles';
import { CAMPAIGN_NAME_FIELD_TEST_IDS } from './campaign-name-field.constants';

interface CampaignNameFieldTextComponentProps {
    title: string,
}

export const CampaignNameFieldTextComponent = ({
    title,
}: CampaignNameFieldTextComponentProps) => (
    <NoTranslate>
        <CampaignNameFieldText
            data-testid={CAMPAIGN_NAME_FIELD_TEST_IDS.CAMPAIGN_NAME}
            title={title}
        >
            {title}
        </CampaignNameFieldText>
    </NoTranslate>
);
